module.exports = __webpack_public_path__ + "img/inspiration.6e099183.png";